<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card class="pa-3">
          <v-card-title>
            <h2 class="title">Create Category</h2>
          </v-card-title>

          <div v-if="loading" class="my-3 px-6">
            <v-progress-linear
              :indeterminate="loading"
              :class="{ 'no-opacity': !loading }"
              style="height: 2px;"
            ></v-progress-linear>
          </div>
          <template v-else>
            <v-card-text class="mt-5">
                <div>
                  <div class="px-2">
                    <v-autocomplete
                      :items="categoryTypes"
                      label="Type"
                      item-text="name"
                      item-value="id"
                      class="mb-3"
                      v-model="preparedData.category_type_id"
                      placeholder="Please Select"
                      :error-messages="errors($v.preparedData.category_type_id) || server_errors.category_type_id"
                      @focus="resetServerValidation"
                    ></v-autocomplete>
                    <v-text-field
                      v-model="preparedData.name"
                      label="Category Name"
                      placeholder="Please Enter"
                      :error-messages="errors($v.preparedData.name) || server_errors.name"
                      @focus="resetServerValidation"
                    ></v-text-field>
                      <v-checkbox
                        v-model="preparedData.green_product"
                        label="Green product"
                        :error-messages="server_errors.green_product"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="preparedData.featured"
                        label="Featured"
                        :error-messages="server_errors.featured"
                      ></v-checkbox>
                    <v-textarea
                      v-model="preparedData.description"
                      name="description"
                      id="description"
                      label="Description"
                      auto-grow
                      rows="1"
                      placeholder="Please Enter"
                      :error-messages="errors($v.preparedData.description) || server_errors.description"
                      @focus="resetServerValidation"
                    ></v-textarea>
                  </div>
                  <v-alert class="pa-2 mt-6" :value="$v.$error" outlined color="error" icon="mdi-alert" transition="scale-transition">
                      <span class="caption">Please fill out form correctly</span>
                  </v-alert>
                  <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert" transition="scale-transition">
                      <span class="caption">{{ serverValidationMessage }}</span>
                  </v-alert>
              </div>
            </v-card-text>

            <v-card-actions class="px-6">
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
                <v-btn 
                  color="primary"
                  :disabled="loadingSave"
                  :loading="loadingSave"
                  @click="CreateCategory"
                >Save
                </v-btn>
            </v-card-actions>
          </template>
      </v-card>
  </v-dialog>
</template>  

<script>
import ApiService from "@/common/api.service"
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import { valMessages, getValMessage } from "@/common/error-messages"

let validations = {
  preparedData: {
    category_type_id: { required },
    name: { required },
    description: { required }
  }
};

export default {
  name: 'CreateCategory',
  mixins: [validationMixin],
  validations,
  data: () => ({
    no_data: [null, "", undefined, "null"],
    item: null,
    preparedData: {},
    categoryTypes: [],
    loading: false,
    loadingSave: false,
    loadingBannerTypes: false,
    dialog: false,
    selectedFileHeight: null,
    selectedFileWidth: null,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),
  mounted () {
    this.$root.$on('CreateCategory', this.openModal)
  },
  beforeDestroy () {
    this.$root.$off('CreateCategory', this.openModal)
  },
  methods: {
    getBannerTypes () {
      this.loadingBannerTypes = true;
      return new Promise((resolve, reject) => {
        ApiService.get("/admin/category_types")
          .then(response => {
            console.log(response)
            let data = response.data;
            this.categoryTypes = data.category_types
            resolve(data);
          })
          .catch(({ response }) => {
            this.loadingBannerTypes = false;
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(
                response.data.error
              );
            }
            reject();
          });
      });
    },
    openModal () {
      this.resetServerValidation()
      this.preparedData = {}
      this.file = null
      this.loading = true
      this.loadingSave = false
      this.$v.$reset()
      this.dialog = true
      this.getBannerTypes()
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.resetServerValidation();
          this.loading = false
        });
    },
    CreateCategory () {
      this.resetServerValidation()
      this.$v.preparedData.$touch()
      if (!this.$v.preparedData.$invalid) {
        this.loadingSave = true
        
        let body = _.cloneDeep(this.preparedData)
        body.featured = this.preparedData.featured || false
        body.green_product = this.preparedData.green_product || false

        ApiService.put('/admin/category', body)
          .then(response => {
            this.$root.$emit("notification", { status: "success", text: `Category has been successfully created`});
            this.loadingSave = false
            this.$emit('done')
            this.closeModal()
          })
          .catch(({ response }) => {
            this.loadingSave = false;
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(
                response.data.error
              );
            }
            if (response.data.message) {
              this.serverValidationMessage = response.data.message;
            }
            if (response.data.errors) {
              this.server_errors = response.data.errors;
            }
          });
      }
    },
    closeModal () {
      this.dialog = false
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
      this.server_errors = {};
    },
    errors: getValMessage(valMessages)(validations)
  }
}
</script>
